import { Component, Input, OnInit } from '@angular/core';
import { ChatMessage } from '../../services/chat-message';

type TemplateData = {
  id: string,
  name: string,
  path: string,
  imageUrl: string,
  catalogImageUrl: string
}

type PresentationData = {
  id: string,
  companyId: string,
  name: string,
  productCode: string
};

@Component({
  selector: 'app-chat-bubble',
  templateUrl: './chat-bubble.component.html',
  styleUrls: ['./chat-bubble.component.scss'],
  standalone: false
})
export class ChatBubbleComponent implements OnInit {
  @Input({ required: true }) message!: ChatMessage;

  messageText: string = '';
  templates: TemplateData[] = [];
  presentations: PresentationData[] = [];

  ngOnInit() {
    const content = this.message.content;

    if (this.isUser) {
      this.messageText = content as unknown as string || '';
    } else if (content.type === 'chat') {
      this.messageText = content.response || '';
    } else if (content.type === 'template_search') {
      this.messageText = 'Sure! Here are some templates that match your request:';
      this.templates = content.response;
    } else if (content.type === 'template_create_from') {
      this.messageText = 'Template created successfully! You can now edit it.';
    } else if (content.type === 'presentation_search') {
      this.messageText = 'Here are the presentations that match your request:';
      this.presentations = content.response;
    } else if (content.type === 'presentation_select') {
      this.messageText = 'The presentation has been selected successfully.';
    } else if (content.type === 'presentation_edit') {
      this.messageText = 'The presentation has been updated successfully.';
    }
  }

  get isUser(): boolean {
    return this.message.role === 'user';
  }

  get isAssistant(): boolean {
    return this.message.role === 'assistant';
  }

  get isError(): boolean {
    return this.message.role === 'error';
  }
}
